import { MaintenanceNoteEffects } from './maintenance-note.effects';
import { MaintenanceScheduleEffects } from './maintenance-schedule.effects';
import { VehiclesDetailEffects } from './vehicles-detail.effects';
import { VehiclePhotoEffects } from './vehicle-photo.effects';
import { VehicleDiagnosticsEffects } from './vehicle-diagnostics.effects';

export const vehiclesEffects = [
  VehiclesDetailEffects,
  VehiclePhotoEffects,
  MaintenanceNoteEffects,
  MaintenanceScheduleEffects,
  VehicleDiagnosticsEffects,
];
